import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const ACCIDENT = {
  nickname: 'PRODUCTS.ACCIDENT.shortname',
  properties: [
    {
      name: 'accidentType', key: 'ACCIDENT_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.NON_MANUAL_WORK', value: 'NON_MANUAL_WORK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.MANUAL_LAND_WORK', value: 'MANUAL_LAND_WORK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.SEAFARERS_FISHERS_OFFSHORE', value: 'SEAFARERS_FISHERS_OFFSHORE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.LEISURE_INSURANCE', value: 'LEISURE_INSURANCE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.CHILDREN', value: 'CHILDREN' }
        ]
      }
    },
    { name: 'wtcAccidentCoverage', key: 'ACCIDENT_COVERAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.PROGRESSIVE_COMPENSATION',
            value: 'PROGRESSIVE_COMPENSATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.PROFESSIONAL_DISABILITY',
            value: 'PROFESSIONAL_DISABILITY'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.SPORTS_EXTENSION',
            value: 'SPORTS_EXTENSION'
          }
        ]
      }
    },
    {
      name: 'accidentActivityType', key: 'ACCIDENT_ACTIVITY_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.NOT_COVERED', value: 'NOT_COVERED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.FOOTBALL', value: 'FOOTBALL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.RUGBY_AMERICAN_FOOTBALL', value: 'RUGBY_AMERICAN_FOOTBALL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.DOWNHILL_RACING', value: 'DOWNHILL_RACING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.FREESTYLE', value: 'FREESTYLE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.BANDY_AND_SKATING', value: 'BANDY_AND_SKATING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.ICE_HOCKEY', value: 'ICE_HOCKEY' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.BOBSLEIGH_LUGE', value: 'BOBSLEIGH_LUGE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.SPORT_DIVING', value: 'SPORT_DIVING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.PROFESSIONAL_DIVING', value: 'PROFESSIONAL_DIVING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.HANDBALL', value: 'HANDBALL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.SNOWBOARD_RACING', value: 'SNOWBOARD_RACING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.MOUNTAIN_BIKING', value: 'MOUNTAIN_BIKING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.COMPETITION_CYCLING', value: 'COMPETITION_CYCLING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.HORSE_RACING', value: 'HORSE_RACING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.BOXING', value: 'BOXING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.WRESTLING', value: 'WRESTLING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.JUDO', value: 'JUDO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.KARATE', value: 'KARATE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.CAR_RACING', value: 'CAR_RACING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.MOTORCYCLE_RACING', value: 'MOTORCYCLE_RACING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_ACTIVITY_TYPE.BOAT_RACING', value: 'BOAT_RACING' }
        ]
      }
    },
    {
      name: 'accidentSumInsuredDisability', key: 'ACCIDENT_SUM_INSURED_INCAPACITY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_SUM_INSURED_INCAPACITY.500000',
            value: '500000'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_SUM_INSURED_INCAPACITY.1000000',
            value: '1000000'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_SUM_INSURED_INCAPACITY.2000000',
            value: '2000000'
          }
        ]
      }
    },
  ],
  lifeInsurance: true,
  icon: 'accident'
};
